// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"297":"643bbcdf","816":"3e27cf93"}[chunkId] + ".chunk.css";
};